import styled from "@emotion/styled";
import {
  PRIMARY_BLUE,
  BACKGROUND_LIGHT,
  SECONDARY_GREY,
  SECONDARY_FONT,
  PRIMARY_GREY,
  SUCCESS_GREEN,
  SUCCESS_LIGHT_BACKGROUND,
  HEADING,
  PRIMARY_BLACK,
} from "src/constants/colors";

export const SearchSectionWrapper = styled.div`
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-sizing: border-box;
`;

export const SearchForm = styled.form`
  margin-bottom: 16px;
  position: relative;
`;

export const SearchInputWrapper = styled.div`
  position: relative;

  #digifi-search {
    border: 1px solid ${SECONDARY_GREY};
    padding-left: 50px;
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 20px;
  top: calc(50% - 17px);
  color: ${SECONDARY_FONT};
  pointer-events: none;
  z-index: 3;
`;

export const PlaceholderText = styled.p`
  color: ${SECONDARY_FONT};
  font-style: italic;
  font-size: 14px;
  margin: 8px 0;
`;

export const CustomerCard = styled.div<{
  expanded: boolean;
  selected: boolean;
}>`
  background: ${BACKGROUND_LIGHT};
  border: 1px solid
    ${(props) =>
      props.selected
        ? SUCCESS_GREEN
        : props.expanded
          ? PRIMARY_BLUE
          : SECONDARY_GREY};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 8px;
  cursor: ${({ expanded }) => (expanded ? "default" : "pointer")};
  transition: all 0.2s ease;
  position: relative;

  ${({ expanded }) =>
    !expanded &&
    `
    &:hover {
      background-color: rgba(248, 249, 250, 1);
      border: 1px solid ${PRIMARY_BLUE};
    }
  `}
`;

export const CustomerCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CustomerInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  margin-right: 16px;
`;

export const ChevronWrapper = styled.div<{ expanded: boolean }>`
  color: ${SECONDARY_FONT};
  display: flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  padding: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(248, 249, 250, 1);
    border-radius: 50%;
    color: ${PRIMARY_BLUE};
  }
`;

export const CustomerName = styled.span`
  font-weight: 600;
  color: ${HEADING};
  font-size: 16px;
`;

export const CustomerPhone = styled.span`
  color: ${SECONDARY_FONT};
  font-size: 14px;
`;

export const CustomerDetails = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  background-color: ${PRIMARY_GREY};
  border-radius: 8px;
  padding: 16px;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid ${SECONDARY_GREY};

  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.span`
  color: ${SECONDARY_FONT};
  font-weight: 500;
  font-size: 14px;
  flex-shrink: 0;
`;

export const DetailValue = styled.span`
  color: ${PRIMARY_BLACK};
  font-size: 14px;
  text-align: right;
  font-weight: 500;
`;

export const CardActions = styled.div`
  padding-top: 12px;
  display: flex;
  justify-content: flex-start;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const SuccessBadge = styled.div`
  background-color: ${SUCCESS_LIGHT_BACKGROUND};
  border: 1px solid ${SUCCESS_GREEN};
  color: ${SUCCESS_GREEN};
  font-size: 14px;
  padding: 8px 14px;
  border-radius: 40px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
`;
